<template>
  <div
    id="$address-book$"
    class="address-book fb-col-start-start"
    :class="{ 'pb-48': computedNodes.length > 0 }"
    :style="computedSizeStyle"
  >
    <!-- 部门层级导航 -->
    <common-node-nav
      :nodeNav="nodeNav"
      ref="nodeNav"
      @click="handlerToGoBackTargetNode"
      class="h-44 item-shrink-0"
    ></common-node-nav>

    <div
      v-show="!computedNodes.length && reqStatus"
      class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1 icon-no-data-box"
    >
      <div class="icon-no-data"></div>
      <span class="font-34">暂无数据</span>
    </div>
    <!-- 子级部门列表-->
    <div v-if="computedNodes.length > 0" class="node-list font-34">
      <div
        v-for="(node, idx) in computedNodes"
        class="fb-start-center h-56"
        :class="{
          'h-68': node.studentDingId
        }"
        :key="node.tpId"
        @click="handlerToChangeSelectedStatus(node)"
      >
        <span v-if="isShowSelectBox(node)" class="mr-12 mt-2">
          <i v-show="!isSelected(node)" class="iconfont c-171A1D-40 font-48">
            &#xe66f;
          </i>
          <i v-show="isSelected(node)" class="iconfont c-006AFE font-48">
            &#xe66e;
          </i>
        </span>
        <div
          class="item-flex-1 fb fb-cross-center text-ellipsis"
          :class="{ bb: idx < computedNodes.length - 1 }"
          style="height: 100%"
        >
          <div class="item-flex-1 text-ellipsis">
            <div class="font-34 pr-5 text-ellipsis">
              {{ node.name }}
            </div>
          </div>
          <span
            v-if="isCanOpen(node)"
            class="next"
            @click.stop="handlerToGetSubNodes(node)"
          >
            <i class="iconfont">&#xe714;</i>下级
          </span>
        </div>
      </div>
    </div>
    <div class="result font-26 fb-start-center">
      <div class="item-flex-1 text-ellipsis c-006AFE">
        <span> {{ computedResultText }}</span>
      </div>
      <div>
        <common-button width="95" height="32" @click="handlerToSubmit(true)"
          >确定</common-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { commonNodeNav, commonButton } from '@/components/commonAddressBook'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { deepCopy, setLeft, removeLeft, pushNullUrl } from '@/utils/comUtils'
import API from '@/api'
import { mcConfirm, mcToast, mcSetTitle } from '@/utils/mcSdkUtils'
// 校区、考勤组
// 校区不可勾选；考勤组可勾选
// 均为单选
const NODE_TYPE = {
  campus: 'campusId', // 校区
  group: 'dormGroupId' // 考勤组
}

export default {
  name: 'MSchoolAddressAttendancePeriods',
  components: {
    commonNodeNav,
    commonButton
  },
  props: {},
  data() {
    return {
      LEAVE_ROLE,
      nodeNav: [], // 部门导航条
      depts: [], // 校区列表
      students: [], // 学生列表
      currentType: 1, // 当前层级
      reqStatus: false,
      showConfirm: false,
      curCampusMap: {}, // 当前展示的校区
      selectedCampusMap: {}, // 已选中的的校区
      curGroupMap: {}, // 当前展示的考勤组
      selectedGroupMap: {} // 已选中的考勤组
    }
  },
  computed: {
    /**
     * 计算组件尺寸大小
     */
    computedSizeStyle() {
      return {
        width: `${window.innerWidth}px`,
        height: `${window.innerHeight}px`
      }
    },
    // 当前展示部门
    computedNodes() {
      let _navLen = this.nodeNav.length

      if (_navLen <= 1) return this.mapDeptsData(this.depts)

      let _lastNode = this.nodeNav[_navLen - 1]
      return this.mapDeptsData(_lastNode.dormGroupRespList)
    },
    /**
     * 选择结果文本
     */
    computedResultText() {
      return this.selectedGroupMap.dormGroupName
    },
    nodeNavLen() {
      return this.nodeNav.length
    }
  },
  mounted() {
    this.title && mcSetTitle(this.title)
    pushNullUrl()
    setLeft(this.methodSetLeft)
    this.init()
  },
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  methods: {
    init() {
      this.getListDormGroup()
        .then(res => {
          this.depts = res || []

          // 回显
          this.echoSelectedData()

          this.nodeNav = []
          this.methodUpdateNodeNav({
            tpId: this.corpId,
            name: this.corpName,
            deptId: this.corpId,
            dormGroupRespList: this.depts
          })
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.reqStatus = true
        })
    },
    echoSelectedData() {
      // 要想回显到最后一层，校区 ID 必传
      let { campusId, dormGroupId } = this.selectedMap || {}

      // 校区
      if (!campusId) return

      let _campusList = this.depts.filter(
        item => item[NODE_TYPE.campus] === campusId
      )
      if (!_campusList.length) return
      this.curCampusMap = this.selectedCampusMap = _campusList[0]
      // 考勤组
      if (!dormGroupId) return

      // 在当前校区寻找宿舍组
      let _dormGroupRespList = this.selectedCampusMap.dormGroupRespList || []

      let _groupList = _dormGroupRespList.filter(
        item => item[NODE_TYPE.group] === dormGroupId
      )
      if (!_groupList.length) return
      this.curGroupMap = this.selectedGroupMap = _groupList[0]
    },
    mapDeptsData(nolist) {
      let _mapId
      let _mapName
      let _mapList = []
      if (!(nolist && nolist.length)) return _mapList

      let _navLen = this.nodeNav.length

      if (_navLen <= 1) {
        _mapId = 'campusId'
        _mapName = 'campusName'
      } else if (_navLen === 2) {
        _mapId = 'dormGroupId'
        _mapName = 'dormGroupName'
      }
      _mapList = nolist.map(item => {
        return {
          ...item,
          tpId: item[_mapId],
          name: item[_mapName]
        }
      })
      return _mapList
    },

    // 计算当前节点是否显示勾选框
    isShowSelectBox(node) {
      return !!node[NODE_TYPE.group]
    },
    isSelected(node) {
      if (this.nodeNavLen <= 1) {
        return (
          this.selectedCampusMap[NODE_TYPE.campus] === node[NODE_TYPE.campus]
        )
      }
      if (this.nodeNavLen === 2) {
        return this.selectedGroupMap[NODE_TYPE.group] === node[NODE_TYPE.group]
      }
    },
    // 计算当前节点是否可展开
    isCanOpen(node) {
      return !!(node && node.dormGroupRespList)
    },
    /**
     * 返回目标节点
     */
    handlerToGoBackTargetNode(_node, index) {
      this.methodUpdateNodeNav(undefined, index)
    },
    // 获取当前展示的列表的对象
    getLastNodeMap() {
      let _navLen = this.nodeNav.length
      let _lastNode = this.nodeNav[_navLen - 1]
      return _lastNode
    },
    /**
     * 切换节点勾选状态
     */
    async handlerToChangeSelectedStatus(node) {
      // 节点不展示勾选框
      if (!this.isShowSelectBox(node)) return
      // 校区
      if (node[NODE_TYPE.campus]) {
        // 校区不展示勾选框
      }
      let _group = node[NODE_TYPE.group]

      if (_group) {
        if (this.selectedGroupMap[NODE_TYPE.group] === _group) {
          this.selectedGroupMap = this.curGroupMap = {}
          return
        }
        this.selectedGroupMap = this.curGroupMap = node
      }
    },
    // 处理节点的下一级
    handlerToGetSubNodes(node) {
      // 校区
      let _campusId = node[NODE_TYPE.campus]
      if (_campusId) {
        // 下一级不是当前选中的校区 全部清空
        if (this.selectedCampusMap[NODE_TYPE.campus] !== _campusId) {
          this.resetData()
        }
        this.curCampusMap = this.selectedCampusMap = node
      }

      this.methodUpdateNodeNav(node)
    },
    resetCampus() {
      this.curCampusMap = {}
      this.selectedCampusMap = {}
    },
    resetGroup() {
      this.curGroupMap = {}
      this.selectedGroupMap = {}
    },
    resetData() {
      this.resetCampus()
      this.resetGroup()
    },
    /**
     * 提交选择信息
     */
    handlerToSubmit(commitStatus) {
      if (commitStatus && !this.computedResultText) {
        return mcToast({ msg: '请选择' })
      }
      let _resolveData = {
        campusId: this.selectedCampusMap.campusId,
        campusName: this.selectedCampusMap.campusName,
        dormGroupName: this.selectedGroupMap.dormGroupName,
        dormGroupId: this.selectedGroupMap.dormGroupId
      }
      this.close(deepCopy(_resolveData))
    },
    /**
     * 获取考勤组
     */
    getListDormGroup() {
      return new Promise((resolve, reject) => {
        API.getListDormGroup()
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {})
      })
    },
    /**
     * 更新部门导航条
     */
    methodUpdateNodeNav(node, index) {
      if (index !== undefined && index > -1) {
        this.nodeNav = this.nodeNav.slice(0, index + 1)
      } else {
        let _flag = this.nodeNav.some(
          item => item.tpId && item.tpId === node.tpId
        )
        if (!_flag) {
          this.nodeNav.push(node)
        }
      }
    },
    //  退回拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showConfirm) {
        return false
      }
      this.showConfirm = true
      mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
        .then(btnIndex => {
          if (btnIndex === 1) {
            this.handlerToSubmit(false)
          } else {
            this.showConfirm = false
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  padding-bottom: 45px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .bg-no-data {
    background: #f6f6f6;
  }
  .disabled-choose {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .icon-no-data {
    width: 70px;
    height: 70px;
    background: url('~@/assets/images/staying-student.png');
    background-size: cover;
  }
  > div {
    width: 100%;
    padding: 0 16px;
    background: #ffffff;
    &:first-child {
      ~ div {
        margin-top: 8px;
      }
    }
    &.node-nav {
      background: #f6f6f6;
      margin: 0;
      &.mt-10 {
        margin-top: 8px;
      }
    }
    &.select-all {
      height: 48px !important;
      min-height: 48px;
      line-height: 48px;
    }
    &.node-list {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      > div {
        // height: 68px;

        &:last-child {
          border-bottom: none;
        }
        &.disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
        .next {
          color: #006afe;
          padding-left: 8px;
          border-left: 1px solid rgba(#191f25, 0.12);
          &.disabled-choose {
            cursor: not-allowed;
            opacity: 0.5;
          }
        }
      }
    }
    &.result {
      height: 45px;
      color: #006afe;
      border-top: 1px solid rgba(#191f25, 0.12);
      position: absolute;
      left: 0;
      bottom: 0;
    }

    &.no-data {
      width: 100%;
      height: 100%;
      background: none;
      > span:first-child {
        margin-bottom: 0.4rem;
      }
    }
  }
}
</style>
